/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';

const TeamSvg = ({ primaryColor }) => (
  <>
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.25309 11.0621C10.8933 11.0621 13.0336 8.92185 13.0336 6.28163C13.0336 3.64144 10.8933 1.50113 8.25309 1.50113C5.6129 1.50113 3.4726 3.64144 3.4726 6.28163C3.4726 8.92185 5.6129 11.0621 8.25309 11.0621Z"
        stroke={primaryColor}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4503 1.67916C15.1078 1.49391 15.7974 1.45171 16.4726 1.5554C17.1478 1.65909 17.793 1.90627 18.3646 2.28029C18.9363 2.65431 19.4211 3.14649 19.7865 3.72367C20.1518 4.30085 20.3893 4.94963 20.4829 5.62631C20.5764 6.303 20.5239 6.99188 20.3288 7.64655C20.1336 8.30124 19.8005 8.90651 19.3519 9.4215C18.9031 9.93659 18.3492 10.3495 17.7274 10.6326C17.1057 10.9155 16.4306 11.062 15.7474 11.0621"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.63336 14.5C2.37998 13.4379 3.37116 12.5712 4.52323 11.9728C5.67528 11.3745 6.95441 11.062 8.2526 11.062C9.55078 11.062 10.8299 11.3742 11.982 11.9726C13.1342 12.5708 14.1254 13.4375 14.8721 14.4994"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7475 11.062C17.0458 11.061 18.3252 11.373 19.4774 11.9713C20.6297 12.5697 21.6207 13.4369 22.3666 14.4994"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </>
);

export default TeamSvg;
